import { rotaHome, rotaPermitida, rotaPublica } from "~/constants/roles";
import { useAuthStore } from "~/stores/auth";

/**
 * Guard global de rotas. Antes disso o `auth` era opt-in por página (`middleware: ['auth']`) e só
 * 6 das 33 páginas o declaravam — as outras eram acessíveis por URL por qualquer tipo de usuário.
 * A tabela de quem pode o quê vive em ~/constants/roles.
 */
export default defineNuxtRouteMiddleware((to) => {
  const authStore = useAuthStore();

  if (!authStore.token) authStore.$reset();
  authStore.authenticated = Boolean(authStore.token && authStore.user);

  const publica = rotaPublica(to.path);

  if (!authStore.authenticated) {
    if (publica) return;
    warnToast('Você precisa estar autenticado para acessar esta página');
    return navigateTo('/login');
  }

  const home = rotaHome(authStore.user?.tipo_id);

  if (to.path === '/login' || to.path.startsWith('/login/')) return navigateTo(home);
  if (publica) return;

  if (!rotaPermitida(to.path, authStore.user?.tipo_id)) {
    warnToast('Você não tem permissão para acessar esta página');
    return navigateTo(home);
  }
});
